import { Option } from "@jutro/types";
import { Input } from "@jutro/ui";
import { Control, Controller } from "react-hook-form";
import {
  EdmVisitTimeDuration,
  useEdmGetDefaultVisitDurationQuery,
} from "lib/graphql/megaSchema";
import { ShiftFormSchemaType } from "views/StaffSchedule/StaffScheduleCreator/tools";

type Props = {
  selectedVisitTypes: ShiftFormSchemaType["visitTypes"];
  control: Control<ShiftFormSchemaType>;
  disabled: boolean;
};

type FilteredVisitTypeOption = Option<
  Exclude<
    keyof EdmVisitTimeDuration,
    "PRESCRIPTION_APPOINTMENT" | "SICK_CHILDREN" | "__typename"
  >
>;

export const OverrideVisitDurationInputGroup = ({
  selectedVisitTypes,
  control,
  disabled,
}: Props) => {
  const { data } = useEdmGetDefaultVisitDurationQuery({
    fetchPolicy: "cache-and-network",
  });

  const filteredVisitTypes = selectedVisitTypes.filter(
    ({ value }) =>
      value !== "PRESCRIPTION_APPOINTMENT" && value !== "SICK_CHILDREN",
  ) as FilteredVisitTypeOption[];

  const placeholderData = data?.edmGetDefaultVisitDuration;

  return (
    <div className="grid grid-cols-2 gap-2.5">
      {filteredVisitTypes.map((option) => (
        <Controller
          key={option.value}
          control={control}
          name={`overrideStaffVisitDuration.${option.value}`}
          render={({ field: { onChange, value } }) => (
            <Input
              label={option.label}
              placeholder={
                placeholderData && option.value in placeholderData
                  ? String(placeholderData[option.value])
                  : ""
              }
              disabled={disabled}
              type="number"
              max={59}
              maxLength={2}
              sideElement="min"
              sideElementPosition="end"
              value={value ?? ""}
              onChange={(e) => {
                if (Number(e.target.value) > 59) {
                  return;
                }

                if (Number(e.target.value) === 0) {
                  return onChange(undefined);
                }

                onChange(Number(e.target.value));
              }}
            />
          )}
        />
      ))}
    </div>
  );
};
